import { render, staticRenderFns } from "./systemParams.vue?vue&type=template&id=12808b00&scoped=true"
import script from "./systemParams.vue?vue&type=script&lang=js"
export * from "./systemParams.vue?vue&type=script&lang=js"
import style0 from "./systemParams.vue?vue&type=style&index=0&id=12808b00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12808b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12808b00')) {
      api.createRecord('12808b00', component.options)
    } else {
      api.reload('12808b00', component.options)
    }
    module.hot.accept("./systemParams.vue?vue&type=template&id=12808b00&scoped=true", function () {
      api.rerender('12808b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents-cool/systemParams.vue"
export default component.exports